import { Restriction } from '@mews-commander/data-access';
import { TimeUnit } from '@mews/enums';
import { getDurationAsTimeUnit, getExceptionDuration } from '@mews-commander/utils';
import { getSecondaryTimeUnit } from './secondaryTimeUnits';

const processExceptionValues = (
    { exceptions: { minAdvance, maxAdvance, minLength, maxLength, ...other } }: Pick<Restriction, 'exceptions'>,
    timeUnit: TimeUnit = TimeUnit.Day
) => {
    const getDailyDuration = getDurationAsTimeUnit(TimeUnit.Day);

    // get mixed time unit length (ie Months and Days)
    const min = minLength ? getExceptionDuration(timeUnit)(minLength) : null;
    const max = maxLength ? getExceptionDuration(timeUnit)(maxLength) : null;
    const secondaryTimeUnit = getSecondaryTimeUnit(timeUnit);
    const secondaryMin = minLength && secondaryTimeUnit ? getExceptionDuration(secondaryTimeUnit)(minLength) : null;
    const secondaryMax = maxLength && secondaryTimeUnit ? getExceptionDuration(secondaryTimeUnit)(maxLength) : null;

    return {
        minAdvance: minAdvance ? getDailyDuration(minAdvance) : null,
        maxAdvance: maxAdvance ? getDailyDuration(maxAdvance) : null,
        minLength: min,
        maxLength: max,
        secondaryMinLength: secondaryMin,
        secondaryMaxLength: secondaryMax,
        ...other,
    };
};

export default processExceptionValues;
